import clsx from 'clsx';
interface PolicyDetailProps {
  children: React.ReactNode;
  className?: string;
}
export default function PolicyDetail({
  children,
  className
}: PolicyDetailProps) {
  return <p className={clsx('pt-5 text-base font-normal leading-6', className)} data-sentry-component="PolicyDetail" data-sentry-source-file="PolicyDetail.tsx">
      {children}
    </p>;
}